import { ResetPasswordPayload } from '@/modules/Users/pages/Patient/Patient.types'

class SendPasswordPayloadMapper {
  toPersistence(domainData: ResetPasswordPayload) {
    return {
      celular: domainData?.cellphone,
      email: domainData?.email,
      idClinica: Number(domainData?.clinicId),
      log: domainData?.sendType?.replaceAll('-', '')?.toUpperCase(),
      nomeClinica: domainData?.clinicName,
      nomeCompleto: domainData?.patientName,
      status: domainData?.patientStatus?.toUpperCase(),
    }
  }
}

export default new SendPasswordPayloadMapper()
